import { render, staticRenderFns } from "./AddLabelToConversation.vue?vue&type=template&id=4a946d8b&scoped=true&"
import script from "./AddLabelToConversation.vue?vue&type=script&lang=js&"
export * from "./AddLabelToConversation.vue?vue&type=script&lang=js&"
import style0 from "./AddLabelToConversation.vue?vue&type=style&index=0&id=4a946d8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a946d8b",
  null
  
)

export default component.exports